import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useInvoice} from '../hooks/useInvoice';
import {CollectionMethod, Invoice} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useInvoice();

    return (
        <FormDrawer
            record={{
                id: '',
                amountDue: 0,
                amountPaid: 0,
                currency: 'usd',
                customerId: '',
                customerEmail: '',
                customerName: '',
                description: '',
                number: '',
                paid: false,
                periodStart: '',
                periodEnd: '',
                status: '',
                total: 0,
                collectionMethod: CollectionMethod.send_invoice,
                daysUntilDue: 30,
                created: '',
            } as Invoice}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
